
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/swimwear",
      function () {
        return require("private-next-pages/apparel/swimwear/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/swimwear"])
      });
    }
  